import { useEffect, useState } from "react";
import instance from "../Interceptor/api_instance";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../Components/PageLayout";
import { toDatetimeLocal } from "../Helper/FormatDatetimes";
import { TablePlaceHolder } from "../Components/LoadingAnimations/LoadingAnimations";
import { GetVehicleCondition } from "../Components/Tables/Vehicles/GetVehicleCondition";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExportJobsView = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const headers = [
    t("yard-tables.table-columns.created_at"),
    t("yard-tables.table-columns.report"),
    t("yard-tables.table-columns.status"),
    t("buttons.download"),
  ];
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await instance.get("files/get-export-jobs");
        if (response.status === 200) {
          // Calculate if download link is valid using expires_at datetime
          setData(
            response.data.map((job) => ({
              ...job,
              sas_url:
                job.expires_at && new Date(job.expires_at) <= new Date()
                  ? null // expired → no URL
                  : job.sas_url,
            }))
          );
          return;
        }
        throw new Error(t("error.fetchingData"));
      } catch (err) {
        console.error("Error fetching export jobs:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <PageLayout title={t("page-headers.exports")}>
      <div className="overview-header">
        <h1 className="global-h1 black">{t("page-headers.exports")}</h1>
        {loading ? (
          <TablePlaceHolder />
        ) : (
          <div>
            <div className="search-filters-cont"></div>
            <div className="table-cont">
              <table id="forwardTable" className="yard-table">
                <thead>
                  <tr className="table-header">
                    {headers.map((header, index) => (
                      <th scope="col" key={`${header}-${index}`}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((job, index) => (
                    <tr key={index} className="data-rows">
                      <td className="gray" key={`${job.created_at}-${index}`}>
                        {toDatetimeLocal(job.created_at)}
                      </td>
                      <td className="gray" key={`${job.report_type}-${index}`}>
                        {t(`report_types.${job.report_type}`)}
                      </td>
                      <td className="gray" key={`${job.status}-${index}`}>
                        <GetVehicleCondition condition={job.status} />
                      </td>
                      <td className="gray" key={`download-${index}`}>
                        <a href={job.sas_url} target="_blank">
                          <FontAwesomeIcon
                            icon={faDownload}
                            style={{
                              color: job.sas_url ? "#2563eb" : "lightgray",
                              cursor: job.sas_url ? "pointer" : "not-allowed",
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default ExportJobsView;
